class LungCancerCalculator {
  constructor(element) {
    this.element = element;
    this.years = this.element.querySelector('[data-element="lung-cancer-calculator-years"]');
    this.packs = this.element.querySelector('[data-element="lung-cancer-calculator-packs"]');
    this.result = this.element.querySelector('[data-element="lung-cancer-calculator-result"]');
    this.output = this.element.querySelector('[data-element="lung-cancer-calculator-output"]');
    this.buttons = this.element.querySelector('[data-element="lung-cancer-calculator-buttons"]');

    this.yearsValue = 0;
    this.packsValue = 0;
    this.outputResult = 0;
    this.outputDivisionNumber = parseFloat(this.result.dataset.calculationDivision);
    this.outputMinResult = parseFloat(this.result.dataset.resultMin);
    this.outputPositiveText = this.output.dataset.positiveText;
    this.outputNegativeText = this.output.dataset.negativeText;
  }

  init() {
    this.years.addEventListener('change', this.onInputChange.bind(this));
    this.years.addEventListener('input', this.onInputChange.bind(this));
    this.packs.addEventListener('change', this.onInputChange.bind(this));
    this.packs.addEventListener('input', this.onInputChange.bind(this));
  }

  onInputChange() {
    this.formatInputs();
    this.validateInputs();

    if (0 === this.yearsValue || 0 === this.packsValue) {
      this.reset();
      return;
    }

    let outputResult = (this.yearsValue * this.packsValue) / this.outputDivisionNumber;

    if (outputResult % 1 !== 0) {
      outputResult = outputResult.toFixed(1);
    }

    this.outputResult = outputResult;
    this.result.textContent = this.outputResult;
    this.showOutput();

    if (this.outputResult >= this.outputMinResult) {
      this.showButtons();
    } else {
      this.hideButtons();
    }
  }

  formatInputs() {
    let yearsValue = this.years.value;
    let packsValue = this.packs.value;

    yearsValue = yearsValue.replace(/[^\d.,]/g, '');
    packsValue = packsValue.replace(/[^\d.,]/g, '');

    if (yearsValue.includes('.') && yearsValue.split('.')[1].length > 2) {
      this.years.value = parseFloat(yearsValue).toFixed(2);
    }

    if (packsValue.includes('.') && packsValue.split('.')[1].length > 2) {
      this.packs.value = parseFloat(packsValue).toFixed(2);
    }
  }

  validateInputs() {
    this.yearsValue = parseFloat(this.years.value);
    this.packsValue = parseFloat(this.packs.value);

    if (this.yearsValue % 1 !== 0) {
      this.yearsValue = this.yearsValue.toFixed(2);
    }

    if (this.packsValue % 1 !== 0) {
      this.packsValue = this.packsValue.toFixed(2);
    }

    if (isNaN(this.yearsValue) || this.yearsValue < 0) {
      this.yearsValue = 0;
    }

    if (isNaN(this.packsValue) || this.packsValue < 0) {
      this.packsValue = 0;
    }
  }

  reset() {
    this.result.textContent = 0;
    this.hideOutput();
    this.hideButtons();
  }

  showOutput() {
    let message = null;

    if (this.outputResult >= this.outputMinResult) {
      message = this.outputPositiveText;
    } else {
      message = this.outputNegativeText;
    }

    this.output.innerHTML = message.replace('{{{#}}}', '<strong>' + this.outputResult + '</strong>');
    this.output.classList.add('show');
  }

  hideOutput() {
    this.output.classList.remove('show');
  }

  showButtons() {
    this.buttons.classList.add('show');
  }

  hideButtons() {
    this.buttons.classList.remove('show');
  }
}

const lungCancerCalculator = {
  init() {
    const lungCancerCalculatorItems = document.querySelectorAll('[data-module="lung-cancer-calculator"]');

    if (lungCancerCalculatorItems) {
      lungCancerCalculatorItems.forEach((item) => {
        const lungCancerCalculatorItem = new LungCancerCalculator(item);
        lungCancerCalculatorItem.init();
      });
    }
  },
};

export default lungCancerCalculator;
